// Écrit --zs-cookie-h : la hauteur que le bandeau de consentement aux cookies de Shopify occupe en bas de la fenêtre (0 quand il
// est fermé ou absent). Sert seulement à décaler la barre d'achat fixe des fiches (voir zs-cookies.css). Ne lit ni n'écrit aucun
// cookie, ne touche ni au texte ni aux boutons du bandeau.
(() => {
  const racine = document.documentElement;
  let banniere = null;
  let taille = null;
  let style = null;

  const mesurer = () => {
    const b = document.getElementById('shopify-pc__banner');
    let h = 0;
    if (b && getComputedStyle(b).display !== 'none') {
      h = Math.max(0, Math.round(window.innerHeight - b.getBoundingClientRect().top));
    }
    racine.style.setProperty('--zs-cookie-h', `${h}px`);
    if (b !== banniere) {
      taille?.disconnect();
      style?.disconnect();
      banniere = b;
      if (b) {
        taille = new ResizeObserver(mesurer);
        taille.observe(b);
        style = new MutationObserver(mesurer);
        style.observe(b, { attributes: true, attributeFilter: ['style', 'class'] });
      }
    }
  };

  // Le script de Shopify ajoute le bandeau à la page après le chargement, et le retire une fois le choix fait
  new MutationObserver(mesurer).observe(document.body, { childList: true });
  window.addEventListener('resize', mesurer);
  mesurer();
})();
